/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = true;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/$.library.js
 ** module id = 510
 ** module chunks = 0
 **/